import Carousel from '../../components/base/Carousel';
import InfoCard from '../../components/InfoCard';

/**
 * Инициализация карусели "Программа ухода"
 * И карточек внутри неё
 */
export default () => {
    const $carouselReviews = $('.carousel--review-photos');
    const carouselReviews = new Carousel($carouselReviews);
    const infoCards = new InfoCard($carouselReviews.find('.info-cards'));

    infoCards.init();

    // Нужно навешивать на "load", чтобы корректно были подсчитаны размеры
    $(window).on('load', () => {
        carouselReviews.init(
            {
                lazy: true,
                spaceBetween: 2,
                loop: false,
            },
            {
                slidesPerView: 6,
                slideToClickedSlide: false,
                breakpoints: {
                    1023: { slidesPerView: 5 },
                    767: { slidesPerView: 4 },
                    479: { slidesPerView: 3 },
                    399: { slidesPerView: 2 },
                },
            }
        );
    });
};
